import React, { useEffect, useState } from 'react';
import { FaBuilding, FaSave, FaSpinner } from 'react-icons/fa';
import empresaApi from '../../../services/api/empresaApi';

const EMPTY = {
  ruc: '',
  razon_social: '',
  rubro: '',
  direccion: '',
};

const MantenimientoEmpresa = () => {
  const [form, setForm] = useState(EMPTY);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState(null);
  const [exists, setExists] = useState(false);

  const loadEmpresa = async () => {
    setLoading(true);
    setMsg(null);
    try {
      const res = await empresaApi.obtener();
      const data = res.data;
      setForm({
        ruc: data.ruc || '',
        razon_social: data.razon_social || '',
        rubro: data.rubro || '',
        direccion: data.direccion || '',
      });
      setExists(true);
    } catch (e) {
      if (e.response?.status === 404) {
        setForm(EMPTY);
        setExists(false);
      } else {
        setMsg({ type: 'error', text: e.response?.data?.detail || 'Error al cargar datos de empresa' });
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadEmpresa();
  }, []);

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    setMsg(null);
    try {
      await empresaApi.guardar(form);
      setExists(true);
      setMsg({ type: 'success', text: 'Datos de empresa guardados correctamente' });
    } catch (err) {
      setMsg({
        type: 'error',
        text: err.response?.data?.detail || 'No se pudo guardar la empresa',
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="dh-reporte-bg" style={{ minHeight: '100vh', padding: '1.5rem' }}>
      <style>{`
        .dh-reporte-bg { background: linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%); }
        .dh-main-header { background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: #fff; padding: 1.5rem; border-radius: 12px; margin-bottom: 1.5rem; }
        .dh-main-title { font-size: 1.5rem; font-weight: 700; margin: 0; }
        .dh-main-subtitle { margin: 0.25rem 0 0; opacity: 0.85; }
        .dh-card { background: #fff; border-radius: 12px; box-shadow: 0 2px 12px rgba(0,0,0,0.08); padding: 1.25rem; margin-bottom: 1rem; }
        .dh-card-header { font-weight: 700; margin-bottom: 1rem; padding-bottom: 0.5rem; border-bottom: 2px solid #667eea; color: #333; }
        .btn-dh-primary { background: linear-gradient(135deg, #11998e, #38ef7d); color: #fff; border: none; padding: 0.5rem 1.25rem; border-radius: 8px; font-weight: 600; }
        .dh-form-label { font-weight: 600; font-size: 0.85rem; margin-bottom: 0.35rem; display: block; }
        .dh-form-control { border-radius: 8px; border: 1px solid #ddd; padding: 0.5rem 0.75rem; width: 100%; }
        .dh-form-control:focus { outline: none; border-color: #667eea; box-shadow: 0 0 0 3px rgba(102,126,234,0.15); }
        .dh-alert-info { background: #e8f4fd; border: 1px solid #b6d4fe; border-radius: 8px; padding: 0.75rem 1rem; color: #084298; }
      `}</style>

      {msg && (
        <div className={`alert ${msg.type === 'error' ? 'alert-danger' : 'alert-success'} alert-dismissible`}>
          {msg.text}
          <button type="button" className="btn-close" onClick={() => setMsg(null)} />
        </div>
      )}

      <div className="dh-main-header">
        <h1 className="dh-main-title"><FaBuilding className="me-2" />Empresa</h1>
        <p className="dh-main-subtitle">
          Datos de la empresa empleadora para todos los proyectos (boleta de pago)
        </p>
      </div>

      <div className="dh-card">
        <div className="dh-alert-info mb-3">
          Configure el RUC, razón social, rubro y dirección. Esta información se usará en las boletas de planilla.
        </div>

        {loading ? (
          <div className="text-center py-4 text-muted">
            <FaSpinner className="fa-spin me-2" /> Cargando...
          </div>
        ) : (
          <form onSubmit={handleSave}>
            <div className="dh-card-header">Datos de la empresa</div>
            <div className="row g-3">
              <div className="col-md-3">
                <label className="dh-form-label">RUC *</label>
                <input
                  className="dh-form-control"
                  value={form.ruc}
                  onChange={(e) => handleChange('ruc', e.target.value)}
                  maxLength={20}
                  required
                />
              </div>
              <div className="col-md-9">
                <label className="dh-form-label">Razón social *</label>
                <input
                  className="dh-form-control"
                  value={form.razon_social}
                  onChange={(e) => handleChange('razon_social', e.target.value)}
                  maxLength={255}
                  required
                />
              </div>
              <div className="col-md-6">
                <label className="dh-form-label">Rubro de la empresa</label>
                <input
                  className="dh-form-control"
                  value={form.rubro}
                  onChange={(e) => handleChange('rubro', e.target.value)}
                  maxLength={255}
                />
              </div>
              <div className="col-md-6">
                <label className="dh-form-label">Dirección</label>
                <input
                  className="dh-form-control"
                  value={form.direccion}
                  onChange={(e) => handleChange('direccion', e.target.value)}
                  maxLength={255}
                />
              </div>
            </div>

            <div className="mt-4 d-flex align-items-center gap-3">
              <button type="submit" className="btn-dh-primary" disabled={saving}>
                {saving ? <FaSpinner className="fa-spin me-1" /> : <FaSave className="me-1" />}
                {exists ? 'Actualizar' : 'Guardar'}
              </button>
              {!exists && (
                <span className="text-muted small">Aún no hay datos registrados.</span>
              )}
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default MantenimientoEmpresa;
